import { useState, useEffect } from 'react'
import { useParams, Link, useNavigate } from 'react-router-dom'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import SEO from '../components/SEO'

export default function WidgetLeads() {
  const { id } = useParams()
  const [leads, setLeads] = useState([])
  const [topQuestions, setTopQuestions] = useState([])
  const [businessName, setBusinessName] = useState(id)
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')
  const navigate = useNavigate()
  const token = sessionStorage.getItem('tredex_widget_token')

  const hotLeadsCount = leads.filter(l => l.leadIntent === 'hot').length

  useEffect(() => {
    (async () => {
      setLoading(true)
      try {
        const [clientRes, leadsRes] = await Promise.all([
          fetch(`/api/widget/admin/clients/${id}`, { headers: { 'Authorization': `Bearer ${token}` } }),
          fetch(`/api/widget/admin/leads/${id}`, { headers: { 'Authorization': `Bearer ${token}` } })
        ])
        if (leadsRes.status === 401 || clientRes.status === 401) {
          sessionStorage.removeItem('tredex_widget_token')
          navigate('/admin/widget/login', { replace: true })
          return
        }
        const clientData = await clientRes.json()
        const leadsData = await leadsRes.json()
        if (clientData.client) setBusinessName(clientData.client.businessName)
        setLeads(leadsData.leads || [])
        setTopQuestions(leadsData.topQuestions || [])
      } catch (err) {
        console.error(err)
      } finally {
        setLoading(false)
      }
    })()
  }, [id])

  return (
    <>
      <SEO title={`Leads - ${businessName}`} noIndex />
      <Navbar />
      <div className="dashboard-page">
        <div className="container">
          <div className="dash-header">
            <div>
              <h1><i className="fas fa-chart-line"></i> Leads & Insights</h1>
              <p>What customers are asking {businessName}.</p>
            </div>
            <Link to="/admin/widget/clients" className="btn btn-outline"><i className="fas fa-arrow-left"></i> Back</Link>
          </div>

          {loading ? (
            <p style={{ padding: '30px', textAlign: 'center', color: 'var(--text-muted)' }}>Loading insights...</p>
          ) : (
            <>
              {topQuestions.length > 0 && (
                <div className="profile-card" style={{ marginBottom: '24px' }}>
                  <h3><i className="fas fa-fire"></i> Top Questions ({topQuestions.length})</h3>
                  <p style={{ color: 'var(--text-muted)', fontSize: '0.9rem', marginBottom: '16px' }}>
                    Hand these to the client as their "what customers want to know" summary.
                  </p>
                  <ol style={{ paddingLeft: '20px', listStyle: 'decimal' }}>
                    {topQuestions.map((q, i) => (
                      <li key={i} style={{ marginBottom: '10px' }}>
                        <strong>{q.message}</strong> <span className="badge confirmed">{q.count}x</span>
                      </li>
                    ))}
                  </ol>
                </div>
              )}

              <div className="profile-card">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', flexWrap: 'wrap', gap: '10px' }}>
                  <h3 style={{ margin: 0 }}><i className="fas fa-envelope-open-text"></i> All Questions ({leads.length})</h3>
                  <div style={{ display: 'flex', gap: '8px' }}>
                    <button className={`btn btn-sm ${filter === 'all' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setFilter('all')}>All</button>
                    <button className={`btn btn-sm ${filter === 'hot' ? 'btn-primary' : 'btn-outline'}`} onClick={() => setFilter('hot')}>
                      🔥 Hot Leads {hotLeadsCount > 0 ? `(${hotLeadsCount})` : ''}
                    </button>
                  </div>
                </div>
                {leads.length === 0 ? (
                  <p style={{ color: 'var(--text-muted)', padding: '20px 0' }}>
                    No questions logged yet. They'll appear here as customers chat with the widget.
                  </p>
                ) : (() => {
                  const filtered = filter === 'hot' ? leads.filter(l => l.leadIntent === 'hot') : leads
                  if (filtered.length === 0 && filter === 'hot') return <p style={{ color: 'var(--text-muted)', padding: '20px 0' }}>No hot leads in this period.</p>
                  return (
                    <table className="admin-table">
                      <thead>
                        <tr>
                          <th>When</th>
                          <th>Message</th>
                          <th>Page</th>
                          <th>User</th>
                          <th>Intent</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filtered.map((l, i) => (
                          <tr key={i}>
                            <td style={{ whiteSpace: 'nowrap', color: 'var(--text-muted)' }}>
                              {new Date(l.timestamp).toLocaleString()}
                            </td>
                            <td>{l.message}</td>
                            <td style={{ maxWidth: '220px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={l.pageUrl}>
                              {l.pageUrl || <span style={{ color: 'var(--text-muted)' }}>—</span>}
                            </td>
                            <td style={{ whiteSpace: 'nowrap' }}>
                              {l.userEmail || l.userId || <span style={{ color: 'var(--text-muted)' }}>guest</span>}
                            </td>
                            <td>
                              {l.leadIntent === 'hot' ? <span className="badge hot">Hot Lead</span> : <span className="badge" style={{ background: '#eee', color: '#666' }}>Normal</span>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )
                })()}
              </div>
            </>
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}
